/*
 * This file is part of glowingblue/newvigation.
 *
 * Copyright (c) 2023 Glowing Blue AG.
 * Authors: Rafael Horvat.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import { extend } from 'flarum/common/extend';
import app from 'flarum/forum/app';
import * as webbinaro_calendar from '@webbinaro-calendar';
import IndexPageHero from './components/IndexPageHero';

// Make translation calls shorter
const t = app.translator.trans.bind(app.translator);

export default function () {
	if (app.initializers.has('webbinaro-calendar')) {
		extend(webbinaro_calendar.components.CalendarPage.prototype, 'view', function (vnode) {
			const title = t('flarum-calendar.forum.button.landing');
			const icon = 'fas fa-calendar-alt';

			vnode.children[0] = <IndexPageHero title={title} icon={icon} />;
		});
	}
}
